import * as Sentry from '@sentry/react';
if (FRONTEND_SENTRY_DSN) {
    Sentry.init({
        dsn: FRONTEND_SENTRY_DSN,
        environment: FRONTEND_SENTRY_ENV || 'production',
        autoSessionTracking: true,
    });
}
